import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

export const buttonStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    primaryColor: {
        backgroundColor: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        '&:hover': { backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryColorLight || 'rgb(0, 155, 223)' },
        '&:active': { backgroundColor: theme?.app?.clientTheme.colors.primaryColorDark || '#243246' }
    },
    approveColor: {
        backgroundColor: theme?.app?.applicationColors.successDark || '#91303c',
        '&:hover': { backgroundColor: theme?.app?.applicationColors.success || '#AF3B49' },
        '&:active': { backgroundColor: theme?.app?.applicationColors.successLight || '#d6858e' }
    },
    declineColor: {
        backgroundColor: theme?.app?.applicationColors.failure || '#AF3B49',
        '&:hover': { backgroundColor: theme?.app?.applicationColors.failureDark || '#91303c' },
        '&:active': { backgroundColor: theme?.app?.applicationColors.failureLight || '#d6858e' }
    },
    submitButtonStyle: {
        display: 'inline-flex' as 'inline-flex',
        cursor: 'pointer',
        textAlign: 'center' as 'center',
        alignItems: 'center' as 'center',
        justifyContent: 'center' as 'center',
        textTransform: 'uppercase' as 'uppercase',
        borderRadius: '26px',
        fontWeight: 'bold' as 'bold',
        color: theme?.app?.applicationColors.enumColors.white || '#FFF',
        '&:disabled': { backgroundColor: theme?.app?.applicationColors.disabledItemColor || '#C8C8C8' },
        '&:active:disabled': { backgroundColor: theme?.app?.applicationColors.enumColors.greyLight || '#A9A9A9' }
    },
    defaultStyle: {
        height: '3.2rem',
        width: '18rem'
    },
    tightStyle: {
        height: '2.8rem',
        width: '10rem'
    }
}));

export const iconStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    buttonIcon: {
        width: '28px',
        height: '28px',
        marginRight: '1rem'
    }
}));